// Selección del filtro de usuarios del Administrador Plus, compartida por
// todos los módulos (se conserva al cambiar de pestaña, no entre recargas).
// apiAuth.js la manda en cada llamada a /api como header X-Filtro-Usuarios y
// el backend (auth/alcance.js) la aplica a listados y reportes. Vacía = Todos.
import { useEffect, useState } from 'react';

let seleccion = [];
const suscriptores = new Set();

export const getFiltroUsuarios = () => seleccion;

export const setFiltroUsuarios = (ids) => {
  seleccion = ids;
  suscriptores.forEach(fn => fn(seleccion));
};

// Devuelve la selección actual; los módulos la usan como dependencia de su
// useEffect de carga (p.ej. `useFiltroUsuarios().join(',')`) para recargar
// al cambiar el filtro sin perder sus propios filtros.
export function useFiltroUsuarios() {
  const [valor, setValor] = useState(seleccion);
  useEffect(() => {
    suscriptores.add(setValor);
    return () => suscriptores.delete(setValor);
  }, []);
  return valor;
}
